import { ArrowUpRight } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionTitle } from "@/components/Shared";
import { PARTNERS } from "@/data/site";

export const PartnersSection = () => {
  return (
    <section data-testid="partners-section" className="relative overflow-hidden bg-[#050505] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionTitle eyebrow="GLOBAL COLLABORATION" title="Partners In Grassroots Motorsport" />
        <p className="mt-5 max-w-2xl leading-relaxed text-white/60">{PARTNERS.intro}</p>

        <StaggerGroup className="mt-14 grid gap-6 md:grid-cols-2">
          {PARTNERS.items.map((p) => (
            <StaggerItem key={p.name}>
              <div className="group flex h-full flex-col overflow-hidden rounded-xl border border-white/10 bg-obsidian transition-all hover:-translate-y-2 hover:border-kbcyan/50">
                {p.image ? (
                  <div className="relative h-52 overflow-hidden">
                    <img src={p.image} alt={p.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    <div className="absolute inset-0 bg-gradient-to-t from-obsidian to-transparent" />
                  </div>
                ) : (
                  <div className="flex h-52 items-center justify-center bg-gradient-to-br from-white/[0.06] to-transparent">
                    <div className="rounded-xl bg-white px-8 py-6">
                      <img src={p.logo} alt={p.name} className="h-20 w-auto" />
                    </div>
                  </div>
                )}
                <div className="flex flex-1 flex-col p-8">
                  {p.image && (
                    <div className="mb-5 inline-flex w-fit items-center rounded-lg bg-white px-4 py-2.5">
                      <img src={p.logo} alt={p.name} className="h-9 w-auto" />
                    </div>
                  )}
                  <h3 className="font-display text-3xl tracking-wide text-white">{p.name}</h3>
                  <p className="mt-3 flex-1 leading-relaxed text-white/55">{p.desc}</p>
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`partner-visit-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="group/btn mt-6 inline-flex w-fit items-center gap-2 rounded-xl bg-kbyellow px-6 py-3 font-display text-xl tracking-wide text-black transition-transform hover:scale-[1.03]"
                  >
                    Visit {p.name}
                    <ArrowUpRight className="h-5 w-5 transition-transform group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                  </a>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default PartnersSection;
